
import React from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';
import { loftyHandleCountShoppingCart } from '../../util/handleCount';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './portfolio.scss';








const Pportfolio = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {






  
  
  
  

  
  return (
    <div id="id6353093593bf11cc1baddfce" >

      <div id="if9wqu" className="">
      
      <div id="ihuh" className="">
      
      <div id="inlc" className="">
      
      <img
        className=""
        id="illj"
        src="https://assetsprojects.s3.amazonaws.com/eewk3il9h8z7ui.png"
        alt="undefined"
      />
      
      <div id="ici8dx" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="idpf" className="">
      
      <div id="i7cvw" className="">
      
      <div className="" id="i2d1h">
        
      <a
        target=""
        className="link "
        id=""
        href=""
        type=""
      >
        
      </a>
      
      <a
        target=""
        className="link "
        id=""
        href=""
        type=""
      >
        <>Fabricación Digital</>
      </a>
      
      </div>
      <>
        </>
      </div>
      
      <div id="i9ute" className="">
      
      <div className="" id="ihn67">
        
      <a
        target=""
        className="link "
        id=""
        href=""
        type=""
      >
        
      </a>
      
      <a
        target=""
        className="link "
        id=""
        href=""
        type=""
      >
        <>Herramientas</>
      </a>
      
      </div>
      <>
        </>
      </div>
      
      <div id="i4d8t" className="">
      
      <div className="" id="izded">
        
      <a
        target=""
        className="link "
        id=""
        href=""
        type=""
      >
        
      </a>
      
      <a
        target=""
        className="link "
        id=""
        href=""
        type=""
      >
        <>Materiales de Impresión</>
      </a>
      
      </div>
      <>
        </>
      </div>
      
      <div id="ihh3i" className="">
      
      <div className="" id="ih8nn">
        
      <a
        target=""
        className="link "
        id=""
        href=""
        type=""
      >
        
      </a>
      
      <a
        target=""
        className="link "
        id=""
        href=""
        type=""
      >
        <>Contacto</>
      </a>
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="izrqjl" className="">
      
      <div className="" id="id8lda">
        
      <i className="" id="">
        <>HAMBURGER</>
      </i>
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="itkxb" className="">
      
      <div id="igk42" className="">
      
      <div id="i2k9f" className="">
      <>
        </>
      </div>
      
      <div id="i8yjmg" className="">
      
      <div id="i1giw1" className="">
      
      <div id="ir7b67" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div className="" id="iqqtir">
        <>Portafolio</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iqrg2c" className="">
      
      <div id="iybi2m" className="">
      <>
        </>
      </div>
      
      <div id="inrd62" className="">
      
      <div className="" id="iytiv9">
        <>Tipo de Material</>
      </div>
      
      <div className="" id="iz6kkb">
        <>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Placerat vestibulum, id imperdiet urna molestie odio. Volutpat turpis condimentum nec neque vitae, netus ut malesuada.</>
      </div>
      <>
        </>
      </div>
      
      <div id="i93yy4" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i79nhx" className="">
      
      <div id="ilawjs" className="">
      <>
        </>
      </div>
      
      <div id="iwc9uq" className="gjs-row ">
      
      <div id="i225kn" className="gjs-cell ">
      
      <div id="i86bjo" className="">
      
      <div className="" id="iubvki">
        <>Modeling</>
      </div>
      
      <div className="" id="iqk98g">
        <>CONCEPTUALIZACIÓN</>
      </div>
      
      <div className="" id="i2qbth">
        
    <div id="" className="">
    <>Impresión sobre plástico</>
    </div>
    
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div id="i4mbhx" className="gjs-cell ">
      
      <div id="ij78fe" className="">
      <>
        </>
      </div>
      
      <div id="iuq5rd" className="">
      
      <div className="" id="i4hwm3">
        <>Modeling</>
      </div>
      
      <div className="" id="itn9tz">
        <>CONCEPTUALIZACIÓN</>
      </div>
      
      <div className="" id="iym76r">
        
    <div id="" className="">
    <>Impresión sobre plástico</>
    </div>
    
      </div>
      
      <div className="" id="ivli0j">
        
    <div id="" className="">
    <>14” al x 14” ancho</>
    </div>
    
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div id="itbygo" className="gjs-cell ">
      
      <div id="i8cf3k" className="">
      
      <div className="" id="il598c">
        <>Modeling</>
      </div>
      
      <div className="" id="i2cxdh">
        <>CONCEPTUALIZACIÓN</>
      </div>
      
      <div className="" id="i2oht1">
        
    <div id="" className="">
    <>Impresión sobre plástico</>
    </div>
    
      </div>
      
      <div className="" id="ibx0m7">
        
    <div id="" className="">
    <>14” al x 14” ancho</>
    </div>
    
      </div>
      <>
        </>
      </div>
      
      <div id="i4f58n" className="">
      <>
        </>
      </div>
      
      </div>
      
      </div>
      
      <div id="inabor" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ixjb7g" className="">
      
      <div id="iqz0wy" className="">
      <>
        </>
      </div>
      
      <div id="irhufq" className="">
      
      <div className="" id="ic4tqi">
        <>Tipo de Material</>
      </div>
      
      <div className="" id="i4km5p">
        <>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Placerat vestibulum, id imperdiet urna molestie odio. Volutpat turpis condimentum nec neque vitae, netus ut malesuada.</>
      </div>
      <>
        </>
      </div>
      
      <div id="in1i1u" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iy0kzs" className="">
      
      <div id="igd98s" className="">
      <>
        </>
      </div>
      
      <div id="i0r22k" className="gjs-row ">
      
      <div id="im9aj8" className="gjs-cell ">
      
      <div id="i5cbcs" className="">
      
      <div className="" id="izm6hd">
        <>Modeling</>
      </div>
      
      <div className="" id="ism2ml">
        <>CONCEPTUALIZACIÓN</>
      </div>
      
      <div className="" id="i60fbk">
        
    <div id="" className="">
    <>Impresión sobre plástico</>
    </div>
    
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div id="ib32hv" className="gjs-cell ">
      
      <div id="ie3crw" className="">
      <>
        </>
      </div>
      
      <div id="iicpbi" className="">
      
      <div className="" id="igyj4a">
        <>Modeling</>
      </div>
      
      <div className="" id="ifcma2">
        <>CONCEPTUALIZACIÓN</>
      </div>
      
      <div className="" id="iteo37">
        
    <div id="" className="">
    <>Impresión sobre plástico</>
    </div>
    
      </div>
      
      <div className="" id="i46q5l">
        
    <div id="" className="">
    <>14” al x 14” ancho</>
    </div>
    
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div id="i1npuo" className="gjs-cell ">
      
      <div id="itq5v7" className="">
      
      <div className="" id="ivg7vp">
        <>Modeling</>
      </div>
      
      <div className="" id="io1i0m">
        <>CONCEPTUALIZACIÓN</>
      </div>
      
      <div className="" id="ij74ak">
        
    <div id="" className="">
    <>Impresión sobre plástico</>
    </div>
    
      </div>
      
      <div className="" id="ioor6e">
        
    <div id="" className="">
    <>14” al x 14” ancho</>
    </div>
    
      </div>
      <>
        </>
      </div>
      
      <div id="i2j4rg" className="">
      <>
        </>
      </div>
      
      </div>
      
      </div>
      
      <div id="is2zfi" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ilkxzh" className="">
      
      <div className="" id="ikgcxg">
        <>© 2022 blackmaker,  All Rights Reserved</>
      </div>
      <>
        </>
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pportfolio);
  